/**
 *
 * scrollRestore - Utility to scroll page to the top of the subnav.
 * @param {Object} options - ScrollToOptions that can be passed in (https://developer.mozilla.org/en-US/docs/Web/API/ScrollToOptions)
 *
 */

const scrollRestore = (options = {}) => {

    const HEADER_CLASS = '.mlb-header';
    const header = document.querySelector(HEADER_CLASS);
    const headerHeight = header?.clientHeight ?? 0;

    window.scrollTo({
        top: (headerHeight && window.scrollY >= headerHeight) ? headerHeight : 0,
        ...options,
    });

};

export default scrollRestore;
